import { createTheme, responsiveFontSizes } from '@mui/material';

const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      // Custom Breakpoints
      lm: 400, // Large Mobile
    },
  },
  palette: {
    primary: {
      main: '#00305E',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#11728D',
      contrastText: '#FFFFFF',
    },
    lighterTeal: '#68D3E3',
    text: {
      primary: '#000000',
      secondary: '#FFFFFF',
    },
    background: {
      white: '#FFFFFF',
    },
    divider: '#FFFFFF',
  },
  typography: {
    fontFamily: 'Raleway, Roboto',
    fontSize: 16,
    heading: {
      fontFamily: {
        primary:"Raleway",
        secondary:"Roboto"
      },
    },
    body: {
      fontFamily: {
        primary:"Roboto",
        secondary:"Raleway"
      },
    }
  },
});

export default responsiveFontSizes(customTheme);
